import {
  RankingBoardBannerRightImage,
  RankingBoardBannerTitleWrapper,
  RankingBoardBannerWrapper,
  RankingBoardWrapper,
  RankingBox,
  RankingBoxListItemWrapper,
  RankingBoxListWrapper,
  RankingBoxWrapper,
  RankingBackgroundLayer,
  RankingItemContent,
  RANK_BACKGROUNDS,
  RankingItemContentInfoWrapper,
  RankingItemContentScoreWrapper,
  RankingBoardNextpageButton,
} from "./styles";
import { useRankingBoard } from "./hooks";

const RankingBoard = () => {
  const {
    pub,
    currentBgIndex,
    getFirstBoxName,
    getSecondBoxName,
    getThirdBoxName,
    firstBoxData,
    secondBoxData,
    thirdBoxData,
    getScoreUnit,
    aniPage,
    getScore,
    nowSeason,
    isGapWidth,
    isNotAutoNextPage,
    getFirstBoxInfo,
    getSecondBoxInfo,
    getThirdBoxInfo,
    setRealNextPage,
    isNotAutoPage2,
  } = useRankingBoard();

  // 랭킹 아이템 렌더링 함수
  const renderRankingItem = (item: any, index: number) => {
    const rank = item.rank || index + 1;
    const animationDelay = 0; // 각 아이템마다 0.08초씩 지연

    if (rank <= 3) {
      return (
        <RankingBoxListItemWrapper
          key={`${aniPage}-${item.id || index}`}
          rank={rank}
          $animationDelay={animationDelay}
        >
          {RANK_BACKGROUNDS[rank as keyof typeof RANK_BACKGROUNDS].map(
            (bg, bgIndex) => (
              <RankingBackgroundLayer
                key={bgIndex}
                $opacity={currentBgIndex === bgIndex ? 1 : 0}
                $background={bg}
                $isActive={currentBgIndex === bgIndex}
              />
            ),
          )}
          <RankingItemContent>
            <RankingItemContentInfoWrapper rank={rank}>
              <img
                src={`/image-web/tier/${item.rank}.png`}
                alt="rank"
                className="rank"
              />
              <div className="name">{item.nickname}</div>
            </RankingItemContentInfoWrapper>

            <RankingItemContentScoreWrapper
              isGapWidth={isGapWidth(item.item)}
              rank={rank}
            >
              <img src={`/image-web/tier/${item.tier}.png`} alt="tier" />
              <div className="score">
                {getScore(item.score)} {getScoreUnit(item.item)}
              </div>
            </RankingItemContentScoreWrapper>
          </RankingItemContent>
        </RankingBoxListItemWrapper>
      );
    } else {
      return (
        <RankingBoxListItemWrapper
          key={`${aniPage}-${item.id || index}`}
          rank={rank}
          $animationDelay={animationDelay}
        >
          <RankingItemContent>
            <RankingItemContentInfoWrapper rank={rank}>
              <div className="rank-text">
                {rank}
                <span>위</span>
              </div>
              <div className="name">{item.nickname}</div>
            </RankingItemContentInfoWrapper>
            <RankingItemContentScoreWrapper
              isGapWidth={isGapWidth(item.item)}
              rank={rank}
            >
              <img src={`/image-web/tier/${item.tier}.png`} alt="tier" />
              <div className="score">
                {getScore(item.score)} {getScoreUnit(item.item)}
              </div>
            </RankingItemContentScoreWrapper>
          </RankingItemContent>
        </RankingBoxListItemWrapper>
      );
    }
  };
  return (
    <RankingBoardWrapper>
      <RankingBoardBannerWrapper>
        <RankingBoardBannerTitleWrapper>
          <div className="pub-name">{pub?.cafeName}</div>
          <div className="season-name">RUNNER PUB {nowSeason?.seasonName}</div>
        </RankingBoardBannerTitleWrapper>
        <RankingBoardBannerRightImage src="/image-web/tier/pub-logo.png" />
      </RankingBoardBannerWrapper>
      <RankingBoxWrapper>
        <RankingBox>
          <div className="title" key={`title-${aniPage}-first`}>
            {getFirstBoxName()}
          </div>

          <RankingBoxListWrapper>
            {firstBoxData.map((item, index) => renderRankingItem(item, index))}
            <div className="info">{getFirstBoxInfo()}</div>
          </RankingBoxListWrapper>
        </RankingBox>
        <RankingBox>
          <div className="title" key={`title-${aniPage}-second`}>
            {getSecondBoxName()}
          </div>

          <RankingBoxListWrapper>
            {secondBoxData.map((item, index) => renderRankingItem(item, index))}
            <div className="info">{getSecondBoxInfo()}</div>
          </RankingBoxListWrapper>
        </RankingBox>
        <RankingBox>
          <div className="title" key={`title-${aniPage}-third`}>
            {getThirdBoxName()}
          </div>

          <RankingBoxListWrapper>
            {thirdBoxData.map((item, index) => renderRankingItem(item, index))}
            <div className="info">{getThirdBoxInfo()}</div>
          </RankingBoxListWrapper>
        </RankingBox>
      </RankingBoxWrapper>
      {!isNotAutoNextPage || isNotAutoPage2 ? null : (
        <RankingBoardNextpageButton
          src="/image-web/tier/next-page.svg"
          onClick={() => {
            setRealNextPage();
          }}
        />
      )}
    </RankingBoardWrapper>
  );
};

export default RankingBoard;
